import { SwitchField } from '@dev-spendesk/grapes';
import type { FormikProps } from 'formik';

import { useTranslation } from 'common/hooks/useTranslation';
import { DefaultTaxAccountCodeFormField } from 'modules/bookkeep/settings/integrations/pages/LegacyIntegrationsAccountingPage/sections/TaxAccountsSection/TaxAccountLocalOnlySection/DefaultTaxAccountCodeFormField';
import { DefaultTaxAccountRateFormField } from 'modules/bookkeep/settings/integrations/pages/LegacyIntegrationsAccountingPage/sections/TaxAccountsSection/TaxAccountLocalOnlySection/DefaultTaxAccountRateFormField';
import type { FormValues } from 'modules/onboarding/setup-hub/pages/Accounting/AccountingVatAccounts/form';

type Props = Pick<
  FormikProps<FormValues>,
  'values' | 'setFieldValue' | 'handleChange' | 'errors' | 'submitCount'
>;

export const DefaultVatAccountForm = ({
  values,
  setFieldValue,
  handleChange,
  errors,
  submitCount,
}: Props) => {
  const { t } = useTranslation('global');

  return (
    <div className="flex flex-col gap-8 rounded-4 bg-background-secondary-default px-24 py-16">
      <SwitchField
        helpText={t('setupHub.vatAccounts.vat.defaultVatDescription')}
        label={t('setupHub.vatAccounts.vat.defaultVatLabel')}
        name="useDefaultValue"
        isChecked={values.useDefaultValue}
        onChange={handleChange}
      />
      {values.useDefaultValue && (
        <div className="flex gap-16">
          <DefaultTaxAccountCodeFormField
            error={submitCount > 0 ? errors.code : undefined}
            value={values.code}
            onChange={(value) => setFieldValue('code', value)}
            visuallyHideLabel
          />
          <DefaultTaxAccountRateFormField
            error={submitCount > 0 ? errors.rate : undefined}
            value={values.rate}
            onChange={(value) => setFieldValue('rate', value)}
            visuallyHideLabel
          />
        </div>
      )}
    </div>
  );
};
